/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { DegreePlan_LearnerAdmissionStatus as LearnerAdmissionStatus } from '__generated__/graphql-types';

import type { Theme } from '@coursera/cds-core';

import TipNeedMoreFlexibility from 'bundles/degree-home/components/v3-dpm/components/HelpTips/TipNeedMoreFlexibility';
import TipReadyForFullDegree from 'bundles/degree-home/components/v3-dpm/components/HelpTips/TipReadyForFullDegree';
import TipReadyForYourNextDegreeCourse from 'bundles/degree-home/components/v3-dpm/components/HelpTips/TipReadyForYourNextDegreeCourse';
import TipReadyToEarnMoreCredit from 'bundles/degree-home/components/v3-dpm/components/HelpTips/TipReadyToEarnMoreCredit';
import useCurriculum from 'bundles/degree-home/components/v3-dpm/lib/useCurriculum';

const styles = {
  helpTipsWrapper: (theme: Theme) => css`
    display: flex;
    gap: ${theme.spacing(32)};
    margin-bottom: ${theme.spacing(32)};
    flex-wrap: wrap;
    overflow: hidden; /* Allows child border-radius */
    ${theme.breakpoints.down('xs')} {
      gap: ${theme.spacing(16)};
    }
  `,
};

export const HelpTipsWrapper: React.FC = ({ children }) => {
  return <div css={styles.helpTipsWrapper}>{children}</div>;
};

export const HelpTips: React.VFC<{ learnerAdmissionStatus: LearnerAdmissionStatus }> = ({ learnerAdmissionStatus }) => (
  <HelpTipsWrapper>
    <TipReadyToEarnMoreCredit learnerAdmissionStatus={learnerAdmissionStatus} />
    <TipReadyForFullDegree learnerAdmissionStatus={learnerAdmissionStatus} />
    <TipReadyForYourNextDegreeCourse learnerAdmissionStatus={learnerAdmissionStatus} />
    <TipNeedMoreFlexibility />
  </HelpTipsWrapper>
);

const HelpTipsEntrypoint: React.VFC = () => {
  const { data } = useCurriculum();

  const learnerAdmissionStatus = data?.Degree?.queryById?.curriculum?.learnerAdmissionStatus;

  if (!learnerAdmissionStatus) {
    return null;
  }

  return <HelpTips learnerAdmissionStatus={learnerAdmissionStatus} />;
};

export default HelpTipsEntrypoint;
